<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Create New POS</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Latter Code"
                class="mb-0"
                type="text"
                required
                placeholder="Latter Code"
                v-model="posData.latter_code"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="NPOS Name"
                class="mb-0"
                type="text"
                required
                placeholder="NPOS Name"
                v-model="posData.npos_name"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="3">
              <a>Province</a>
              <multiselect
                v-model="valueProvince"
                :options="optionsProvince"
                class="mb-0 mt-2"
                placeholder="Pilih Province"
                label="province_name"
                track-by="province_name"
                @input="getDistrict"
              ></multiselect>
            </CCol>
            <CCol :col="3">
              <a>District</a>
              <multiselect
                v-model="valueDistrict"
                :options="optionsDistrict"
                class="mb-0 mt-2"
                placeholder="Pilih District"
                label="district_name"
                track-by="district_name"
                :disabled="districtDisable"
                @input="getSubDistrict"
              ></multiselect>
            </CCol>
            <CCol :col="3">
              <a>Sub District</a>
              <multiselect
                v-model="valueSubDistrict"
                :options="optionsSubDistrict"
                class="mb-0 mt-2"
                placeholder="Pilih Sub District"
                label="sub_district_name"
                track-by="sub_district_name"
                :disabled="districtSubDisable"
              ></multiselect>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Contact Number"
                class="mb-0"
                type="email"
                placeholder="Contact Number"
                v-model="posData.contact_number"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Latlong"
                class="mb-0"
                type="text"
                required
                placeholder="Latlong : -6.398010, 106.970424"
                v-model="posData.latlong"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CTextarea
                label="Address"
                class="mb-0"
                type="text"
                required
                Vertical
                placeholder="Address"
                v-model="posData.address"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Status"
                :options="optionsStatus"
                type="options"
                required
                placeholder="Select Status"
                v-model="posData.status"
                @change="handleStatus"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="POS Interpack"
                :options="optionsPOSInterpack"
                type="options"
                required
                placeholder="Select Options"
                v-model="posData.is_pos_interpack"
                @change="handlePOSInterpack"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="GMB (Google My Business)"
                class="mb-0"
                type="text"
                placeholder="GMB (Google My Business)"
                v-model="posData.google_mybusiness"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                :disabled="buttonDisable"
                color="success"
                class="float-right"
                @click="createPOS"
              >Create</CButton>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import jwt from "jsonwebtoken";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  name: "UserCreate",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  data() {
    return {
      posData: {
        latter_code: "",
        npos_name: "",
        sub_district_id: 0,
        address: "",
        contact_number: "",
        latlong: "",
        status: "ACTIVE",
        is_pos_interpack: false,
        google_mybusiness: "",
      },
      valueProvince: {},
      optionsProvince: [],
      valueDistrict: {},
      optionsDistrict: [],
      valueSubDistrict: {},
      optionsSubDistrict: [],
      districtDisable: true,
      districtSubDisable: true,
      optionsStatus: ["ACTIVE", "INACTIVE"],
      optionsPOSInterpack: [{value: true, label: "ACTIVE"}, {value: false, label: "INACTIVE"}],
      buttonDisable: false,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.getProvince();
  },
  watch: {
    valueProvince: function () {
      if (this.valueProvince === null) {
        this.valueDistrict = {};
        this.valueSubDistrict = {};
        this.districtDisable = true;
        this.districtSubDisable = true;
      }
    },
  },
  computed: {},
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "NPOS" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/agent/network" });
    },
    handleStatus(event) {
      this.posData.status = event.target.value;
    },
    handlePOSInterpack(event) {
      this.posData.is_pos_interpack = event.target.value === 'true';
    },
    getProvince() {
      axios
        .get(`${this.domain}/v1/location/province/data`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.optionsProvince = response.data.data;
        })
        .catch(() => {});
    },
    getDistrict() {
      if (this.valueProvince !== null) {
        this.districtDisable = false;
        axios
          .get(
            `${this.domain}/v1/location/district/data?page=1&per_page=100&province_id=${this.valueProvince.province_id}`,
            {
              headers: {
                Authorization: this.token,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            this.optionsDistrict = response.data.data;
          })
          .catch(() => {});
      } else {
        this.valueProvince = {};
        this.valueDistrict = {};
        this.valueSubDistrict = {};
        this.districtDisable = true;
        this.districtSubDisable = true;
      }
    },
    getSubDistrict() {
      if (this.valueDistrict !== null) {
        this.districtSubDisable = false;
        axios
          .get(
            `${this.domain}/v1/location/subdistrict/data?page=1&per_page=100&district_id=${this.valueDistrict.district_id}`,
            {
              headers: {
                Authorization: this.token,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            this.optionsSubDistrict = response.data.data;
          })
          .catch(() => {});
      } else {
        this.districtSubDisable = true;
        this.valueDistrict = {};
        this.valueSubDistrict = {};
      }
    },
    createPOS() {
      this.posData.sub_district_id = this.valueSubDistrict.sub_district_id;
      if (this.posData.sub_district_id === undefined) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Location harus di isi",
        });
      } else {
        axios
          .post(`${this.domain}/v1/pos`, this.posData, {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          })
          .then(() => {
            // JSON responses are automatically parsed.
            Swal.fire({
              icon: "success",
              title: `POS Created`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({ path: `/agent/network` });
          })
          .catch((err) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: err.response.data.message.id,
            });
          });
      }
    },
  },
};
</script>

<style scoped>
@import "./Network.css";
</style>
